module.exports = __webpack_public_path__ + "media/images/pa_logo-0f2524462f62320fab3594d083b2758a.svg";